import React from "react"
import { useDispatch, useSelector } from "react-redux";
import {
    Modal
} from "reactstrap"
import { resetModal } from "../../../store/actions/modalActions";

const ConfirmationModal = ({ title, question, onConfirm }) => {
  const dispatch = useDispatch();
  const { isOpen } = useSelector((state) => state.modal);

  const closeModal = () => {
    dispatch(resetModal());
  };

  return (
    <React.Fragment>
      <Modal size="xl" isOpen={isOpen} className="modal-fullscreen confirmationContainer">
        <div className="modal-header">
          <div className="close">
            <i className="fas fa-times" onClick={closeModal}></i>
          </div>
        </div>
        <div className={"modal-body"}>
          <div>
            <h3>{question}</h3>
            <button className="ConfirmationBtn" onClick={onConfirm}>
              Confirm delete
            </button>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default ConfirmationModal
